import { DataBean } from "../DataBean";

export class MarketPlaceGuide extends DataBean {

    public async getMarketPlaceForTransportGuide(idAgency: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.MarketPlace_getMarketPlaceForTransportGuide_Number", [idAgency]);
    }

}